"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_commands_1 = require("prosemirror-commands");

var Node_1 = __importDefault(require("./Node"));

var Paragraph =
/*#__PURE__*/
function (_Node_1$default) {
  _inherits(Paragraph, _Node_1$default);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _possibleConstructorReturn(this, _getPrototypeOf(Paragraph).apply(this, arguments));
  }

  _createClass(Paragraph, [{
    key: "keys",
    value: function keys(_ref) {
      var type = _ref.type;
      return {
        "Shift-Ctrl-0": prosemirror_commands_1.setBlockType(type)
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref2) {
      var type = _ref2.type;
      return function () {
        return prosemirror_commands_1.setBlockType(type);
      };
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      if (node.textContent.trim() === "" && node.childCount === 0 && !state.inTable) {
        state.write("\\\n");
      } else {
        state.renderInline(node);
        state.closeBlock(node);
      }
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        block: "paragraph"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "paragraph";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: "inline*",
        group: "block",
        parseDOM: [{
          tag: "p"
        }],
        toDOM: function toDOM() {
          return ["p", 0];
        }
      };
    }
  }]);

  return Paragraph;
}(Node_1.default);

exports.default = Paragraph;